export default __webpack_public_path__ + "static/media/arrowToken.07136f8e.svg";